
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class MailDtoModel extends Model<MailDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'taskActionId', type: 'string' },
		{ name: 'subject', type: 'string' },
		{ name: 'content', type: 'string' },
		{ name: 'recipients', type: 'string[]', isArray: true },
		{ name: 'mailData', type: 'string' },
		{ name: 'trackingId', type: 'string' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public taskflowId?: string;
	public taskActionId?: string;
	public subject: string;
	public content: string;
	public recipients: string[];
	public mailData: string;
	public trackingId?: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.taskflowId = undefined;
		this.taskActionId = undefined;
		this.subject = '';
		this.content = '';
		this.recipients = [];
		this.mailData = '';
		this.trackingId = undefined;
		
	}
	getProperties(){
		return MailDtoModel.classProperties;
	}
}

